import { DefReactSelectOption } from "../../../types/DefReactSelectOption";
import { SendClientReportOptions } from "../client-report-edit/hooks/ReportPublishContext";

export const SendClientReportOptionDefaults : SendClientReportOptions = {
    adviserMessage: "",
    emailAddressesToNotify: [],
    isNotifiedViaDashboard: false,
    isNotifiedViaEmail: false,
    mailMessage: null,
    mediaType: 1
};

export const SendMediaTypes = {
    'EMAIL': 0,
    'POST': 1,
    'CLIENTDASHBOARD': 2
};

export const SendMediaTypeOptions : DefReactSelectOption<void>[] = [
    { label: 'Email', value: 0, isDisabled: false, isFixed: false, data: null },
    { label: 'Online Dashboard', value: 2, isDisabled: false, isFixed: false, data: null },
    { label: 'Post', value: 1, isDisabled: false, isFixed: false, data: null }
];